<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column" style="z-index: 99999;">
        <header class="py-1 d-flex justify-content-between align-items-center height-60px">
            <h2> {{ "assign_categories_to_vendor" | translate }}</h2>
            <div>

                <button class="btn eod-btn-outline-warning height-38px mr-2" (click)="fnOnAddCategory()">
                    {{'add_category' | translate}}
                </button>

                <button class="btn eod-btn-primary height-38px mr-2" [ngClass]="{ disabled: !hasFormChanges}"
                    (click)="fnOnSave()">
                    {{'label_save' | translate}}
                </button>

                <button type="button" class="btn eod-btn-outline-warning height-38px" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="block mt-0 heightCalc-5">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-12">
                <!----------------------Start Grid--------------------------->
                <app-grid #vendorCategoriesGrid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                    (onCellClick)="fnOnGridCellClick($event)" (onCheckAll)="fnOnGridCheckAll($event)"></app-grid>
                <!----------------------End Grid--------------------------->
            </div>
        </div>
        <app-add-vendor-category-panel *ngIf="isAddVendorCategory" [categoryFormModel]="categoryFormModel"
    (closePanelEvent)="fnOnCloseAddCategory($event)"></app-add-vendor-category-panel>
    </div>
</div>
<app-alert-panel [data]="alertPanelModel" (callbackEvent)="alertPanelReceiver($event)">
</app-alert-panel>
